import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-requirements-modal',
  standalone: false,
  templateUrl: './requirements-modal.component.html',
  styleUrl: './requirements-modal.component.scss'
})
export class RequirementsModalComponent {

  constructor(private dialogRef: MatDialogRef<RequirementsModalComponent>) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
